import { render, staticRenderFns } from "./ParametrosStatusCadastros.vue?vue&type=template&id=288b1928&scoped=true&"
import script from "./ParametrosStatusCadastros.vue?vue&type=script&lang=js&"
export * from "./ParametrosStatusCadastros.vue?vue&type=script&lang=js&"
import style0 from "./ParametrosStatusCadastros.vue?vue&type=style&index=0&id=288b1928&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288b1928",
  null
  
)

export default component.exports